<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 15 15"
       role="presentation"
       @click="$emit('click')">
    <path fill="#979797" fill-rule="nonzero" d="M12 6.5v-1A2.5 2.5 0 0 1 14.5 8v2a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 10V8A2.5 2.5 0 0 1 6 5.5h4v1H6A1.5 1.5 0 0 0 4.5 8v2A1.5 1.5 0 0 0 6 11.5h6a1.5 1.5 0 0 0 1.5-1.5V8A1.5 1.5 0 0 0 12 6.5zm-9 2v1A2.5 2.5 0 0 1 .5 7V5A2.5 2.5 0 0 1 3 2.5h6A2.5 2.5 0 0 1 11.5 5v2A2.5 2.5 0 0 1 9 9.5H5v-1h4A1.5 1.5 0 0 0 10.5 7V5A1.5 1.5 0 0 0 9 3.5H3A1.5 1.5 0 0 0 1.5 5v2A1.5 1.5 0 0 0 3 8.5z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>